import { EFinancingProgram } from '@if/core/types'
import { Button, Typography, useTheme } from '@mui/material'
import { memo, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Applicant } from '../../../data/types'
import CustomerAccountDialog from './customerAccountDialog'

interface Props {
  applicant: Applicant
  userCanApproveCreditApplication: boolean
  creditApplicationId: string
  financingProgramId: EFinancingProgram
  isApplicant: boolean
  editDisabled: boolean
}

const CustomerAccountInformation = ({
  applicant,
  userCanApproveCreditApplication,
  creditApplicationId,
  financingProgramId,
  isApplicant,
  editDisabled,
}: Props) => {
  const { t } = useTranslation()
  const [openCustomerAccountDialog, setOpenCustomerAccountDialog] = useState<boolean>(false)
  const theme = useTheme()

  const onCancel = useCallback(() => {
    setOpenCustomerAccountDialog(false)
  }, [])

  return (
    <>
      {!applicant?.relationWithApplicant && <p>{t('common.applicant')} : </p>}
      {applicant?.relationWithApplicant && <p>{t('common.coApplicant')} : </p>}
      {!applicant?.existingCustomerReference && (
        <Typography
          variant="subtitle1"
          sx={{ backgroundColor: theme.palette.action.selected, marginBottom: 3 }}
          component="p"
        >
          {t('customerAccount.agentMustSelect')}
        </Typography>
      )}
      {applicant?.existingCustomerReference?.customerId === '' && (
        <Typography
          variant="subtitle1"
          sx={{ backgroundColor: theme.palette.action.selected, marginBottom: 3 }}
          component="p"
        >
          {t('customerAccount.noAccountCorresponds')}
        </Typography>
      )}
      {applicant?.existingCustomerReference?.customerId && (
        <Typography
          variant="subtitle1"
          sx={{ backgroundColor: theme.palette.action.selected, marginBottom: 3 }}
          component="p"
        >
          {t('customerAccount.existingCustomerAssociated')}
        </Typography>
      )}
      {userCanApproveCreditApplication && (
        <Button
          id="btnSelectApplicant"
          variant="contained"
          size="large"
          sx={{
            mt: 2,
          }}
          disabled={editDisabled}
          onClick={() => {
            setOpenCustomerAccountDialog(true)
          }}
        >
          {isApplicant ? t('customerAccount.selectApplicant') : t('customerAccount.selectCoApplicant')}
        </Button>
      )}
      <CustomerAccountDialog
        open={openCustomerAccountDialog}
        onCancel={onCancel}
        applicant={applicant}
        creditApplicationId={creditApplicationId}
        financingProgramId={financingProgramId}
        title={t('customerAccount.associateCustomer')}
        isApplicant={isApplicant}
      />
    </>
  )
}

export default memo(CustomerAccountInformation)
